import styled from 'styled-components';

export const Container = styled.div`
  padding: 87px 111px 100px;
`;
